import { gql } from '@apollo/client';

// DD-3702: requests between labs and Denthub Pro clinics.
const clinicRequestFields = `
    _id
    direction
    status
    message
    requestedByName
    requestedAt
    decidedAt
    declineReason
    lab { _id name organizationNumber city }
    clinic { _id name organizationNumber city }
`;

export const incomingClinicRequestsTemplate = gql`
    query incomingClinicRequests($status: ClinicConnectionRequestStatus) {
        incomingClinicRequests(status: $status) {
            ${clinicRequestFields}
        }
    }
`;

export const outgoingClinicRequestsTemplate = gql`
    query outgoingClinicRequests($status: ClinicConnectionRequestStatus) {
        outgoingClinicRequests(status: $status) {
            ${clinicRequestFields}
        }
    }
`;

export const requestClinicConnectionTemplate = gql`
    mutation requestClinicConnection($organizationId: MongoDbObjectId!, $message: String) {
        requestClinicConnection(organizationId: $organizationId, message: $message) {
            ${clinicRequestFields}
        }
    }
`;

export const approveClinicRequestTemplate = gql`
    mutation approveClinicRequest($requestId: MongoDbObjectId!) {
        approveClinicRequest(requestId: $requestId) {
            ${clinicRequestFields}
        }
    }
`;

export const declineClinicRequestTemplate = gql`
    mutation declineClinicRequest($requestId: MongoDbObjectId!, $reason: String) {
        declineClinicRequest(requestId: $requestId, reason: $reason) {
            ${clinicRequestFields}
        }
    }
`;
